import React from 'react';
import liveInstance from "../liveController/createLiveInstance";

const {
	useRTCEventCallback
} = liveInstance

function useVolumes (props) {
	const [state, updateState] = React.useState([])
	
	useRTCEventCallback('userVolumes', userVolumes => {
		// console.log('音量： ', userVolumes)
		updateState(userVolumes)
	})
	
	return state
}

export { useVolumes } ;
